import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_29: DocMigration = {
  maxSchemaVersion: "0.0.29",
  apply(json: any) {
    // Helper functions
    const renameFields = (o: any) => {
      if (o.wainscoting0) {
        o.masonry0 = o.wainscoting0;
        delete o.wainscoting0;
      }
      if (o.wainscoting1) {
        o.masonry1 = o.wainscoting1;
        delete o.wainscoting1;
      }
      if (o.wainscoting2) {
        o.masonry2 = o.wainscoting2;
        delete o.wainscoting2;
      }
      if (o.wainscotingTrim0) {
        o.masonryTrim0 = o.wainscotingTrim0;
        delete o.wainscotingTrim0;
      }
      if (o.wainscotingTrim1) {
        o.masonryTrim1 = o.wainscotingTrim1;
        delete o.wainscotingTrim1;
      }
      if (o.wainscotingTrim2) {
        o.masonryTrim2 = o.wainscotingTrim2;
        delete o.wainscotingTrim2;
      }
    };

    const renameRegex = new RegExp(`^wainscoting(Trim)?[0-2]$`);
    const renameValue = (o: any, propertyName: string) => {
      if (!o.hasOwnProperty(propertyName)) {
        return;
      }

      if (o[propertyName].match(renameRegex)) {
        o[propertyName] = o[propertyName].replace("wainscoting", "masonry");
      }
    };

    // Document mutations
    if (json.facades) {
      for (const facadeId in json.facades) {
        const facade = json.facades[facadeId];

        if (facade.spanStrata) {
          for (const spanStratum of facade.spanStrata) {
            renameValue(spanStratum, "name");
            renameValue(spanStratum, "material");
          }
        }

        if (facade.sweepStrata) {
          for (const spawnStratum of facade.sweepStrata) {
            renameValue(spawnStratum, "name");
            renameValue(spawnStratum, "material");
          }
        }
      }
    }

    if (json.tables) {
      if (json.tables.settings) {
        for (const settingKey of Object.keys(json.tables.settings)) {
          const setting = json.tables.settings[settingKey];

          renameFields(setting);
          renameValue(setting, "headCasingMaterial");

          if (setting.columnSlices) {
            for (const columnSlice of setting.columnSlices) {
              renameValue(columnSlice, "paletteId");
            }
          }
        }
      }

      if (json.tables.palettes) {
        for (const paletteKey of Object.keys(json.tables.palettes)) {
          const palette = json.tables.palettes[paletteKey];

          renameFields(palette);
        }
      }

      if (json.blocks) {
        for (const blockKey of Object.keys(json.blocks)) {
          const block = json.blocks[blockKey];

          if (block.layouts) {
            for (const layoutKey of Object.keys(block.layouts)) {
              const layout = block.layouts[layoutKey];

              if (layout.rooms) {
                for (const roomKey of Object.keys(layout.rooms)) {
                  const room = layout.rooms[roomKey];

                  if (room.layout && room.layout.openingPatterns) {
                    for (const openingPattern of room.layout.openingPatterns) {
                      if (openingPattern.openings) {
                        for (const opening of openingPattern.openings) {
                          if (opening.exteriorCasing) {
                            renameValue(opening.exteriorCasing, "material");
                            renameValue(opening.exteriorCasing, "headCasingMaterial");
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_29;
